export default __webpack_public_path__ + "static/media/fireBar.988b6fb2.png";